import { render, staticRenderFns } from "./DocumentsGroupTable.vue?vue&type=template&id=c4fa4804&"
import script from "./DocumentsGroupTable.vue?vue&type=script&lang=js&"
export * from "./DocumentsGroupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports